import ajax from '../utils/request'
import { updateApps } from '../views/config/apps'

const loginApi = {
  /********************************登陆管理*********************************** */
  // 登陆
  login(params) {
    return ajax({
      url: '/login',
      type: 'post',
      params: params
    })
  },
  // sso登陆
  slogin(params) {
    return ajax({
      url: '/slogin',
      type: 'post',
      params: params
    })
  },
  // 登陆验证
  verify(params) {
    return ajax({
      url: '/verify',
      type: 'post',
      params: params
    })
  },
  // 刷新token
  refreshToken(params) {
    return ajax({
      url: '/refresh',
      type: 'get',
      params: params
    })
  },
  // 登出
  logout(params) {
    return ajax({
      url: '/logout',
      type: 'post',
      params: params
    })
  },
  // 获取所有APP列表
  async updateApps() {
    try {
      const r = await fetch('https://ht.ilalxqps.com/api/stat/appInfo/type/list', {method: 'post'})
      const rj = await r.json();
      updateApps(rj.data);
    } catch (error) {
      console.error(error);
    }
  },
}
export default loginApi
